import * as yup from "yup";

export const contactFormSchema = yup.object({
  name: yup.string().required("Nome é obrigatório"),
  ddd: yup
    .string()
    .max(12, "DDD deve conter 2 dígitos")
    .matches(/^\+\d{2,12}$/, "DDD deve conter 2 dígitos")
    .required("DDD é obrigatório"),
  phone: yup
    .string()
    .max(24, "Telefone deve conter no máximo 24 dígitos")
    .matches(/^\d{2,24}$/, "Telefone deve conter apenas números")
    .required("Telefone é obrigatório"),
  mail_address: yup
    .string()
    .max(160, "Email deve conter no máximo 160 caracteres")
    .email("Email inválido")
    .required("Email é obrigatório"),
  content: yup.string().required("Mensagem é obrigatória"),
});
